import normalizeComponent from "./component-library92.mjs";
const _sfc_main = {
  name: "CheckMark"
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "xmlns": "http://www.w3.org/2000/svg", "width": "14", "height": "11", "viewBox": "0 0 14 11" } }, [_c("path", { attrs: { "fill-rule": "evenodd", "d": "M12.94.182A.577.577 0 0 1 13.373 0c.174 0 .322.064.443.19A.633.633 0 0 1 14 .645a.59.59 0 0 1-.191.445L4.313 11l-.383-.4c-.034-.048-.573-.58-1.617-1.597A104.012 104.012 0 0 1 .173 6.88.63.63 0 0 1 0 6.426c0-.182.075-.345.226-.49.081-.097.209-.146.383-.146.174 0 .319.06.434.182 1.218 1.283 2.308 2.354 3.27 3.213L12.939.182z" } })]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null,
  null,
  null
);
const CheckMark = __component__.exports;
export {
  CheckMark as default
};
